<template>
  <div
    class="marketplace-beta-toggle-section"
  >
    <div class="marketplace-beta-toggle-section__left">
      <p class="marketplace-beta-toggle-section__title subtitle-1">
        {{ textCopies.title }}
      </p>
      <p class="marketplace-beta-toggle-section__description subtitle-2">
        {{ textCopies.description }}
      </p>
    </div>
    <div class="marketplace-beta-toggle-section__right">
      <AcvToggleSwitch
        v-model="marketplaceBetaEnabled"
        hide-label
        label=""
        round
        :disabled="loading"
        class="marketplace-beta-toggle-section__toggle"
      />
    </div>
  </div>
</template>

<script setup>
import { AcvToggleSwitch } from '@acv/shared-vuejs';
import { computed, ref } from 'vue';
import useAcvStore from '@/composables/useAcvStore';
import useAcvAnalytics from '@/composables/useAcvAnalytics';

const store = useAcvStore();
const analytics = useAcvAnalytics();

const loading = ref(false);
const srpRefreshPreference = computed(() => store.getters['marketplaceView/srpRefreshPreference']);

const handleRefreshChange = () => {
  analytics.track(
    analytics.eventNames.marketplaceV2.srpMarketplaceBetaToggled,
    {
      dealer_id: store.getters.currentUser.defaultDealerId,
      beta_enabled: !srpRefreshPreference.value,
    },
  );
  window.location.reload();
};

const marketplaceBetaEnabled = computed({
  get() {
    return srpRefreshPreference.value;
  },
  async set() {
    loading.value = true;
    await store.dispatch('marketplaceView/toggleSrpRefreshPreference', {
      callbackFn: handleRefreshChange,
    });
  },
});

const textCopies = computed(() => {
  if (marketplaceBetaEnabled.value) {
    return {
      title: 'Beta Marketplace Enabled',
      description: 'You\'re using the beta version of the marketplace. Switch back to the legacy version anytime using this toggle.',
    };
  }
  return {
    title: 'Legacy Marketplace Enabled',
    description: 'You\'re using the legacy version of the marketplace. Switch to the beta version anytime using this toggle.',
  };
});

defineExpose({
  srpRefreshPreference,
  marketplaceBetaEnabled,
});

</script>

<style lang="scss" scoped>
@use '@/scss/search/fonts';

.marketplace-beta-toggle-section {
  padding: 1rem;
  border: 1px solid theme('colors.border.base');
  color: theme('colors.text.secondary');
  position: relative;
  border-radius: 0.75rem;
  display: flex;

  &__title {
    font-weight: theme('fontWeight.medium');
    color: theme('colors.text.primary');
    line-height: 1.5rem;
    margin-bottom: 0;
  }

  &__description {
    font-weight: theme('fontWeight.regular');
    line-height: 1.25rem;
    margin-top: 0.25rem;
    margin-bottom: 0;
    text-transform: initial;
  }

  &__right {
    margin: 0 0 0 auto;
  }
}
</style>
